export default {
    accidents: [],
    accidentsLoading: false,
    accidentTypes: [],
    machines: [],
    accidentLoading: false,
    accidentStatuses: [],
    accidentDepartments: [],
    accidentUserDepartments: [],
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        accidentStatus : null,
        machineId: null,
        accidentDepartment: null,
        createdAt__gte: null,
        createdAt__lte: null,
        lastAssignee: null,
        isSolved: true
    }
}
